import React from 'react';
import { useLocation } from 'react-router-dom';
import { WizardStep } from '../../../../components/Wizard/WizardStep';
import { OnSubmit, useWizard } from '../../../../design-system';
// Retries / retry-interval inputs are temporarily hidden below — the backend doesn't honour
// the hints for the bulk firmware command yet. Un-comment when support lands. The validation
// schema, CommandState shape and mutate plumbing are all left intact so re-enabling is a
// two-line change in this file.
import {
  // RETRIES_MAX,
  // RETRIES_MIN,
  // RETRY_INTERVAL_MAX_SECONDS,
  // RETRY_INTERVAL_MIN_SECONDS,
  UpdateFirmwareFields,
  validationSchema,
} from '../../../../utils/firmware';
import { CommandsWizardState, CommandType } from '../types';

export const UpdateFirmwareStep: React.FC = () => {
  const { state: untypedState, setState: untypedSetState, prevStep, nextStep, step } = useWizard();
  const state = untypedState as Partial<CommandsWizardState>;
  const setState = untypedSetState as (state: Partial<CommandsWizardState>) => void;

  const {
    state: { chargePoints },
  } = useLocation<Pick<CommandsWizardState, 'chargePoints'>>();

  const onlyEvnexChargePoints = chargePoints.every((chargePoint) => chargePoint.vendor === 'Evnex');

  const savedFirmware = state.command?.type === CommandType.UPDATE_FIRMWARE ? state.command : undefined;

  const onCancel = React.useCallback<OnSubmit<UpdateFirmwareFields>>(
    (values: UpdateFirmwareFields) => {
      setState({
        command: {
          type: CommandType.UPDATE_FIRMWARE,
          firmwareUrl: values.firmwareUrl,
          retries: values.retries,
          retryInterval: values.retryInterval,
        },
      });
      prevStep();
    },
    [setState, prevStep],
  );

  const onSubmit = React.useCallback<OnSubmit<UpdateFirmwareFields>>(
    (values: UpdateFirmwareFields, { setFieldError }) => {
      setFieldError('firmwareUrl', undefined);
      setState({
        command: {
          type: CommandType.UPDATE_FIRMWARE,
          firmwareUrl: values.firmwareUrl,
          retries: values.retries,
          retryInterval: values.retryInterval,
        },
      });
      nextStep();
    },
    [setState, nextStep],
  );

  return (
    <WizardStep<UpdateFirmwareFields>
      fields={[
        { id: 'firmwareUrl', label: 'Firmware URL' },
        // {
        //   id: 'retries',
        //   label: `Retries (optional, ${RETRIES_MIN}–${RETRIES_MAX})`,
        //   inputProps: { type: 'number', inputProps: { min: RETRIES_MIN, max: RETRIES_MAX, step: 1 } },
        // },
        // {
        //   id: 'retryInterval',
        //   label: `Retry interval in seconds (optional, ${RETRY_INTERVAL_MIN_SECONDS}–${RETRY_INTERVAL_MAX_SECONDS})`,
        //   inputProps: {
        //     type: 'number',
        //     inputProps: { min: RETRY_INTERVAL_MIN_SECONDS, max: RETRY_INTERVAL_MAX_SECONDS, step: 1 },
        //   },
        // },
      ]}
      initialValues={{
        firmwareUrl: savedFirmware?.firmwareUrl ?? '',
        retries: savedFirmware?.retries ?? '',
        retryInterval: savedFirmware?.retryInterval ?? '',
      }}
      name="Enter firmware URL"
      onCancel={onCancel}
      onSubmit={onSubmit}
      step={step}
      subtitle="Enter the URL containing the firmware you wish to update to. Clicking 'Next' will start the upgrade process."
      validationSchema={validationSchema({ chargePointVendor: onlyEvnexChargePoints ? 'Evnex' : 'Other' })}
    />
  );
};
